<template>
    <section class="main">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-rank"></i> 拖拽组件</el-breadcrumb-item>
                <el-breadcrumb-item>拖拽弹框</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <p>通过指令 v-dialogDrag 使 Dialog 对话框具有可拖拽的功能。</p>
            <br>
            <el-button @click="visible = true;" type="primary">点我弹框</el-button>
        </div>
        <el-dialog :visible.sync="visible" center title="拖拽弹框" v-dialogDrag width="30%">
            我是一个可以拖拽的对话框！
            <span class="dialog-footer" slot="footer">
                <el-button @click="visible = false">取 消</el-button>
                <el-button @click="visible = false" type="primary">确 定</el-button>
            </span>
        </el-dialog>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                visible: false
            };
        }
    };
</script>

<style>

</style>
